import { useIntl } from 'react-intl';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { Alert, CircularProgress, Stack } from '@rossum/ui/material';
import { BillingHeader } from './components/BillingHeaders/BillingHeader';
import { OverviewContent } from './components/OverviewContent';
import { billingLayoutContainerStyles } from './helpers';
import { BillingEntity } from './hooks/useBillingEntity';
import { useBillingHistory } from './hooks/useBillingHistory';

type OverviewProps = {
  billingEntity: BillingEntity;
};

const Overview = ({ billingEntity }: OverviewProps) => {
  const intl = useIntl();

  // TODO unpaginated endpoint
  const { data, isSuccess, isLoading, isError } = useBillingHistory(
    billingEntity,
    {
      page: 0,
      pageSize: 100,
    }
  );

  return (
    <PageLayout renderHeader={props => <BillingHeader {...props} />}>
      <Stack sx={billingLayoutContainerStyles} spacing={4} useFlexGap>
        {isSuccess && (
          <OverviewContent
            historyContent={data}
            billingEntity={billingEntity}
          />
        )}
        {isLoading && <CircularProgress />}
        {isError && (
          <Alert severity="error">
            {intl.formatMessage({ id: 'containers.billing.overview.error' })}
          </Alert>
        )}
      </Stack>
    </PageLayout>
  );
};

export { Overview };
